<template>
  <div class="commonRuncardTable">
    <template v-if="!modStatus">
      <b-table
        :items="runcardItem.slice(0, -1)"
        :fields="runcardFields"
        sticky-header="447px"
        :no-border-collapse="true"
        class="text-center orderManagement-common-runcard-table-detail original"
      >
        <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
        <template #cell(screw_weight)="data" style="">
          {{ data.value.toLocaleString("en-US") }}
        </template>
        <template #cell(bucket_weight)="data" style="">
          {{ data.value.toLocaleString("en-US") }}
        </template>
      </b-table>
    </template>
    <template v-else>
      <b-table
        :items="runcardItem"
        :fields="modRuncardFields"
        sticky-header="447px"
        :no-border-collapse="true"
        class="text-center orderManagement-common-runcard-table-detail mod"
      >
        <template v-slot:cell(index)="data">{{
          data.index + 1 != runcardItem.length ? data.index + 1 : ""
        }}</template>
        <template #cell(runcard_code)="data">
          <template v-if="data.index + 1 != runcardItem.length">
            <input
              type="text"
              @blur="checkChangeInput('runcard_code', data.index)"
              v-model="runcardItem[data.index].runcard_code"
              style="width: 157px;height: 100%;"
              class="text-center"
            />
          </template>
        </template>
        <template #cell(furnace_code)="data">
          <template v-if="data.index + 1 != runcardItem.length">
            <input
              type="text"
              @blur="checkChangeInput('furnace_code', data.index)"
              v-model="runcardItem[data.index].furnace_code"
              style="width: 157px;height: 100%;"
              class="text-center"
            />
          </template>
        </template>
        <template #cell(screw_weight)="data">
          <template v-if="data.index + 1 != runcardItem.length">
            <input
              type="number"
              min="0"
              @blur="checkChangeInput('screw_weight', data.index)"
              v-model="runcardItem[data.index].screw_weight"
              style="width: 157px;height: 100%;"
              class="text-center"
            />
          </template>
        </template>
        <template #cell(bucket_weight)="data">
          <template v-if="data.index + 1 != runcardItem.length">
            <input
              type="number"
              min="0"
              @blur="checkChangeInput('bucket_weight', data.index)"
              v-model="runcardItem[data.index].bucket_weight"
              style="width: 157px;height: 100%;"
              class="text-center"
            />
          </template>
        </template>
        <template v-slot:cell(del)="data">
          <template v-if="data.index + 1 != runcardItem.length">
            <b-button
              size="sm"
              style="height: 21px;line-height: normal;line-height: 13px;background-color: #4b8c80;border-color: #4b8c80;"
              @click="onRuncardDeleteClicked(data.index)"
            >
              刪除
            </b-button>
          </template>
          <template v-else>
            <b-button
              size="sm"
              style="height: 21px;line-height: normal;line-height: 13px;background-color: #4b8c80;border-color: #4b8c80;"
              @click="onRuncardAddClicked()"
            >
              新增
            </b-button>
          </template>
        </template>
      </b-table>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "commonRuncardTable",
  props: {
    workID: {
      type: String
    },
    runcardItem: {
      type: Array,
      default: []
    },
    reason: {
      type: Array,
      default: []
    },
    modStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      runcardFields: [
        {
          key: "index",
          label: "項次",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "runcard_code",
          label: "流程卡號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "furnace_code",
          label: "爐號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "screw_weight",
          label: "重量(KG)",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "bucket_weight",
          label: "桶重(KG)",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        }
      ],
      modRuncardFields: [
        {
          key: "index",
          label: "項次",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "runcard_code",
          label: "流程卡號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "furnace_code",
          label: "爐號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "screw_weight",
          label: "重量(KG)",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "bucket_weight",
          label: "桶重(KG)",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "del",
          label: "刪除",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        }
      ]
    };
  },
  created: function() {},
  mounted: function() {},
  components: {},
  watch: {},
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal"
    }),
    onRuncardAddClicked() {
      let vm = this;
      vm.runcardItem.push({
        index: "",
        in_runcard_code: "",
        runcard_code: "",
        orgRuncard_code: "",
        in_furnace_code: "",
        furnace_code: "",
        orgFurnace_code: "",
        in_screw_weight: "",
        screw_weight: "",
        orgScrew_weight: "",
        in_bucket_weight: "",
        bucket_weight: "",
        orgBucket_weight: "",
        reason: [],
        del: ""
      });
    },
    onRuncardDeleteClicked(index) {
      let vm = this;
      if (vm.runcardItem.length == 2) {
        vm.set_alertMsg("至少需輸入一項生產重量");
        vm.settimeout_alertModal();
        return;
      }
      vm.runcardItem.splice(index, 1);
    },
    checkChangeInput(position, index = null) {
      let vm = this;
      switch (position) {
        case "runcard_code":
          console.log("runcard_code");
          let runcard_code = vm.runcardItem[index].runcard_code;
          if (runcard_code == "" || runcard_code == undefined) {
            vm.runcardItem[index].runcard_code =
              vm.runcardItem[index].orgRuncard_code;
            vm.set_alertMsg(`流程卡號不可為空，請再次確認`);
            vm.settimeout_alertModal();
            return;
          }

          let re = new RegExp(vm.workID + "-[0-9]{2}");
          if (re.test(runcard_code) == false) {
            vm.runcardItem[index].runcard_code =
              vm.runcardItem[index].orgRuncard_code;
            vm.set_alertMsg(`流程卡號格式錯誤，請再次確認`);
            vm.settimeout_alertModal();
            return;
          }

          for (let i = 0; i < vm.runcardItem.length - 1; i++) {
            if (i == index) {
              continue;
            }
            if (vm.runcardItem[i]["runcard_code"] == runcard_code) {
              vm.runcardItem[index].runcard_code =
                vm.runcardItem[index].orgRuncard_code;
              vm.set_alertMsg(`流程卡號已存在，請再次確認`);
              vm.settimeout_alertModal();
              return;
            }
          }

          vm.runcardItem[index].orgRuncard_code = runcard_code;

          var queryIndex = vm.runcardItem[index].reason.indexOf("runcard_code");
          if (vm.runcardItem[index].in_runcard_code != runcard_code) {
            if (queryIndex == -1) {
              vm.runcardItem[index].reason.push("runcard_code");
            }
          } else {
            //舊的跟新的一樣
            if (queryIndex != -1) {
              vm.runcardItem[index].reason.splice(queryIndex, 1);
            }
          }

          // var params = {};
          // params["vuePage"] = vm.selectPage;
          // params["methods"] = "POST";
          // params["runcard_code"] = runcard_code;
          // params["whichFunction"] = "checkChangeInput";
          // vm.axiosAction(params).then(() => {
          //   var result = vm.axiosResult;
          //   if (result["Response"] == "ok") {
          //     vm.runcardItem[index].orgRuncard_code = runcard_code;
          //   } else {
          //     vm.set_alertMsg(`查無此流程卡號，請再次確認`);
          //     vm.settimeout_alertModal();
          //     vm.runcardItem[index].runcard_code =
          //       vm.runcardItem[index].orgRuncard_code;
          //     return;
          //   }
          // });
          break;
        case "furnace_code":
          console.log("furnace_code");
          let furnace_code = vm.runcardItem[index].furnace_code;
          if (furnace_code == "" || furnace_code == undefined) {
            vm.runcardItem[index].furnace_code =
              vm.runcardItem[index].orgFurnace_code;
            vm.set_alertMsg(`爐號不可為空，請再次確認`);
            vm.settimeout_alertModal();
            return;
          }

          vm.runcardItem[index].orgFurnace_code = furnace_code;

          var queryIndex = vm.runcardItem[index].reason.indexOf("furnace_code");
          if (vm.runcardItem[index].in_furnace_code != furnace_code) {
            if (queryIndex == -1) {
              vm.runcardItem[index].reason.push("furnace_code");
            }
          } else {
            //舊的跟新的一樣
            if (queryIndex != -1) {
              vm.runcardItem[index].reason.splice(queryIndex, 1);
            }
          }

          // var params = {};
          // params["vuePage"] = vm.selectPage;
          // params["methods"] = "POST";
          // params["furnace_code"] = furnace_code;
          // params["whichFunction"] = "checkChangeInput";
          // vm.axiosAction(params).then(() => {
          //   var result = vm.axiosResult;
          //   if (result["Response"] == "ok") {
          //     vm.runcardItem[index].orgFurnace_code = furnace_code;
          //   } else {
          //     vm.set_alertMsg(`查無此爐號，請再次確認`);
          //     vm.settimeout_alertModal();
          //     vm.runcardItem[index].furnace_code =
          //       vm.runcardItem[index].orgFurnace_code;
          //     return;
          //   }
          // });
          break;
        case "screw_weight":
          console.log("screw_weight");
          let screw_weight = vm.runcardItem[index].screw_weight;
          if (screw_weight < 0 || screw_weight == "" || isNaN(screw_weight)) {
            vm.runcardItem[index].screw_weight =
              vm.runcardItem[index].orgScrew_weight;
            vm.set_alertMsg(`重量僅能是正數，請再次確認`);
            vm.settimeout_alertModal();
            return;
          }
          vm.runcardItem[index].orgScrew_weight = screw_weight;

          var queryIndex = vm.runcardItem[index].reason.indexOf("screw_weight");
          if (vm.runcardItem[index].in_screw_weight != screw_weight) {
            if (queryIndex == -1) {
              vm.runcardItem[index].reason.push("screw_weight");
            }
          } else {
            //舊的跟新的一樣
            if (queryIndex != -1) {
              vm.runcardItem[index].reason.splice(queryIndex, 1);
            }
          }
          break;
        case "bucket_weight":
          console.log("bucket_weight");
          let bucket_weight = vm.runcardItem[index].bucket_weight;
          if (
            bucket_weight < 0 ||
            bucket_weight == "" ||
            isNaN(bucket_weight)
          ) {
            vm.runcardItem[index].bucket_weight =
              vm.runcardItem[index].orgBucket_weight;
            vm.set_alertMsg(`桶重僅能是正數，請再次確認`);
            vm.settimeout_alertModal();
            return;
          }
          vm.runcardItem[index].orgBucket_weight = bucket_weight;

          var queryIndex = vm.runcardItem[index].reason.indexOf(
            "bucket_weight"
          );
          if (vm.runcardItem[index].in_bucket_weight != bucket_weight) {
            if (queryIndex == -1) {
              vm.runcardItem[index].reason.push("bucket_weight");
            }
          } else {
            //舊的跟新的一樣
            if (queryIndex != -1) {
              vm.runcardItem[index].reason.splice(queryIndex, 1);
            }
          }
          break;

        default:
          break;
      }
    }
  },
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss">
.orderManagement-common-runcard-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.orderManagement-common-runcard-table-detail th,
.orderManagement-common-runcard-table-detail td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-right: 1px solid;
  border-bottom: 1px solid #999999 !important;
  font-size: 1.125rem;
  font-weight: normal;
  vertical-align: middle !important;
}
.orderManagement-common-runcard-table-detail td {
  font-size: 1rem;
}
.orderManagement-common-runcard-table-detail th:first-child,
.orderManagement-common-runcard-table-detail td:first-child {
  border-left: 1px solid;
}
.orderManagement-common-runcard-table-detail thead th {
  color: #ffffff !important;
  background-color: #4b8c80 !important;
}
.orderManagement-common-runcard-table-detail.original tr th:nth-child(1),
.orderManagement-common-runcard-table-detail.original tr td:nth-child(1) {
  width: 55px;
  min-width: 55px;
}
.orderManagement-common-runcard-table-detail.original tr th:nth-child(2),
.orderManagement-common-runcard-table-detail.original tr td:nth-child(2) {
  width: 175px;
  min-width: 175px;
}
.orderManagement-common-runcard-table-detail.original tr th:nth-child(3),
.orderManagement-common-runcard-table-detail.original tr td:nth-child(3) {
  width: 230px;
  min-width: 230px;
}
.orderManagement-common-runcard-table-detail.original tr th:nth-child(4),
.orderManagement-common-runcard-table-detail.original tr td:nth-child(4) {
  width: 485px;
  min-width: 485px;
}
.orderManagement-common-runcard-table-detail.original tr th:nth-child(5),
.orderManagement-common-runcard-table-detail.original tr td:nth-child(5) {
  width: 180px;
  min-width: 180px;
}

.orderManagement-common-runcard-table-detail.mod tr:last-child td:nth-child(n) {
  background-color: transparent;
  border-color: transparent !important;
}
.orderManagement-common-runcard-table-detail.mod tr th:nth-child(1),
.orderManagement-common-runcard-table-detail.mod tr td:nth-child(1) {
  width: 55px;
  min-width: 55px;
}
.orderManagement-common-runcard-table-detail.mod tr th:nth-child(2),
.orderManagement-common-runcard-table-detail.mod tr td:nth-child(2) {
  width: 175px;
  min-width: 175px;
}
.orderManagement-common-runcard-table-detail.mod tr th:nth-child(3),
.orderManagement-common-runcard-table-detail.mod tr td:nth-child(3) {
  width: 230px;
  min-width: 230px;
}
.orderManagement-common-runcard-table-detail.mod tr th:nth-child(4),
.orderManagement-common-runcard-table-detail.mod tr td:nth-child(4) {
  width: 395px;
  min-width: 395px;
}
.orderManagement-common-runcard-table-detail.mod tr th:nth-child(5),
.orderManagement-common-runcard-table-detail.mod tr td:nth-child(5) {
  width: 180px;
  min-width: 180px;
}
.orderManagement-common-runcard-table-detail.mod tr th:nth-child(6),
.orderManagement-common-runcard-table-detail.mod tr td:nth-child(6) {
  width: 90px;
  min-width: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/orderManagement/table/commonRuncardTable.vue